import { FC } from "react";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import ZonesOverview from "@/features/zones/components/overview/ZonesOverview.fetcher";

const ZonesPage: FC = (): JSX.Element => {
  useDocumentTitle("Zones");

  return <ZonesOverview />;
};

export default ZonesPage;
